import Analytics from "../../../frontend/js/analytics.js";

class ExpandAndCollapse {
    constructor() {
        this.addEventListeners();
    }

    addEventListeners() {
        const faqItemTogglers = document.querySelectorAll('.faq-item__toggler');
        if (!faqItemTogglers) return

        faqItemTogglers.forEach(function (link) {
            link.addEventListener('click',
                function (e) {
                    let currentToggler = e.target;
                    let setExpander = currentToggler.getAttribute('aria-expanded');

                    if (setExpander === "true") {
                        setExpander = "false"
                    } else {
                        setExpander = "true"
                        const text = e.target.textContent && e.target.textContent.trim() || ''
                        console.log(text)
                        Analytics.expandFaq(text);
                    }

                    currentToggler.setAttribute('aria-expanded', setExpander);
                    currentToggler.parentElement.classList.toggle('faq-item--open');

                    faqItemTogglers.forEach(toggler => {
                        if (toggler !== currentToggler) {
                            toggler.setAttribute('aria-expanded', 'false');
                            toggler.parentElement.classList.remove('faq-item--open');
                        }
                    })
                });
        });
    }
}
document.addEventListener("DOMContentLoaded", function () {
    new ExpandAndCollapse();
});